<template>
  <div>
    <div v-if="!componentData">
      <b-row class="d-flex justify-content-around align-items-center stats-block-container">
        <template v-for="(value, key) in values">
          <div v-b-modal="`stats-${key}`" class="campaign-score-block d-flex flex-column justify-content-around" :class="{'align-items-start': !isRightAligned, 'align-items-end': isRightAligned,}" :key="`${key}-block`">
            <span class="score-display-count">{{ value }}</span>
            <span class="score-display-label" v-if="labels && labels[key]">{{ labels[key] }}</span>
            <span class="score-display-label" v-else>{{ labels }}</span>
          </div>
          <b-modal
            :key="key"
            :id="`stats-${key}`"
            :title="labels[key]"
            @hide="currentPage = 1"
            size="lg"
            hide-footer
            lazy
          >
            <b-table
              :fields="fields(key)"
              :items="(history || {})[key]"
              :per-page="perPage"
              :current-page="currentPage"
              striped
              hover
            />
            <b-pagination
              v-model="currentPage"
              :items="(history || {})[key]"
              :per-page="perPage"
              :total-rows="((history || {})[key] || []).length"
              align="center"
            />
          </b-modal>
        </template>
      </b-row>
    </div>
    <div v-else>
      <b-row class="d-flex justify-content-around align-items-center stats-block-container">
        <template v-for="({ label, value, key }) in componentData">
          <div class="campaign-score-block d-flex flex-column justify-content-around" :class="{'align-items-start': !isRightAligned, 'align-items-end': isRightAligned,}" :key="`${key}-block`">
            <span class="score-display-count">{{ value }}</span>
            <span class="score-display-label" v-if="label">{{ label }}</span>
            <span class="score-display-label" v-else>{{ key }}</span>
          </div>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
import formatDate from 'date-fns/format';

export default {
  props: {
    labels: {
      type: Object,
      default: null,
    },
    values: {
      type: Object,
      required: false,
    },
    history: {
      type: Object,
      required: false,
    },
    componentData: {
      type: Array,
      required: false,
    },
    isRightAligned: {
      type: Boolean,
      default: false,
    },
    computed: {
      lastKey() {
        return Object.keys(this.values).pop();
      },
    },
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
  }),
  computed: {
    formatDate: () => formatDate,
  },
  methods: {
    fields(key) {
      const fields = [ { key: 'fullName', label: 'User Name' } ];
      if ([ 'JOB_SHARED', 'JOB_VIEWS' ].includes(key)) {
        fields.push({
          key: 'jobTitle',
          formatter: val => `${(val || '').substring(0, 21)}${(val || '').length > 21 ? '...' : ''}`
        });
      }
      if ([ 'CONTENT_SHARED', 'CONTENT_VIEWS' ].includes(key)) {
        fields.push({
          key: 'contentTitle',
          formatter: val => `${(val || '').substring(0, 21)}${(val || '').length > 21 ? '...' : ''}`
        });
      }
      if ([ 'APPLICATIONS_COUNT', 'INTERVIEWS_MADE', 'FINAL_HIRES' ].includes(key)) {
        fields.push({
          key: 'jobTitle',
          formatter: val => `${(val || '').substring(0, 21)}${(val || '').length > 21 ? '...' : ''}`
        });
        fields.push({
          key: 'candidateFullName',
          label: 'Candidate Name',
          formatter: val => `${(val || '').substring(0, 21)}${(val || '').length > 21 ? '...' : ''}`
        });
      }
      fields.push({
        key: 'timestamp',
        formatter: val => formatDate(parseInt(val), 'HH:mm, Do MMM YYYY')
      });
      return fields;
    }
  }
};
</script>

<style lang="scss">
  .campaign-score-block {
    width: 115px;
    height: 52.5px;

    .score-display-count {
      font-weight: bold;
      font-size: 23px;
    }

    .score-display-label {
      font-size: 12px;
      text-align: center;
      text-transform: uppercase;
    }
  }
  .stats-block-container {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/StatsBlock.vue